import config from '../../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';
import { buildTableSuccessActionBasedOnCount } from '../../../utils/actionCreators';

export const ERRORED_PAYOUTS_LOAD = 'ERRORED_PAYOUTS/ERRORED_PAYOUTS_LOAD';
export const ERRORED_PAYOUTS_SUCCESS = 'ERRORED_PAYOUTS/ERRORED_PAYOUTS_SUCCESS';
export const ERRORED_PAYOUTS_FAILURE = 'ERRORED_PAYOUTS/ERRORED_PAYOUTS_FAILURE';

export const fetchUrl = `${config.payoutApiUrl}/errored`;

export function selectErroredPayout(batchRef) {
    return `/errored-payout?batchRef=${batchRef}`;
}

export function getErroredPayouts(filters, page, pageSize, sorters, payoutAccountIds, columns) {
    const queryParamsString = createQueryParams({
        dateKey: 'updatedAt',
        filters,
        payoutAccountIds,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getErroredPayoutsFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: ERRORED_PAYOUTS_LOAD,
        successActionTypeOrCreator: getErroredPayoutsSuccessActionCreator
    };
}

export function getErroredPayoutsSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, ERRORED_PAYOUTS_SUCCESS, 'erroredPayouts');
}

export function getErroredPayoutsFailureActionCreator(error) {
    return {
        error,
        type: ERRORED_PAYOUTS_FAILURE
    };
}
